import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthServiceService } from '../../services/auth-service.service';
import { Credentials } from '../../../../../entities/Credentials';
import { User } from '../../../../../entities/User';import { ProductService } from 'src/app/shared/services/product.service';
import { ToastrService } from 'ngx-toastr';
import { tap } from 'rxjs/operators';
import { RegistroUsuarioServiceService } from '../../../registro-afiliado/services/registro-usuario-service.service';
import { GoogleAnalyticsService } from '../../../../../shared/services/google-analytics.service';

@Component({
  selector: 'app-modal-login',
  templateUrl: './modal-login.component.html',
  styleUrls: ['./modal-login.component.scss']
})
export class ModalLoginComponent implements OnInit {

  loginForm: FormGroup;
  public credentials: Credentials;
  public idUsuario;
  public hide: boolean = true;
  public checkout: boolean = false;
  constructor(
    private router: Router,
    private auth: AuthServiceService,
    private fb: FormBuilder,
    private analytics: GoogleAnalyticsService,
    private prodService: ProductService,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private toastr:ToastrService,
    private service: RegistroUsuarioServiceService,
) { }


  ngOnInit(): void {
   this.initForm();
   this.route.params.subscribe(
    (params) => {
      this.idUsuario = params['idUsuario'];
      if (this.idUsuario != null){
        this.activarUsuario(this.idUsuario);
      }
    }
  )
  this.checkout = this.service.checkout;
  }

  initForm(){
    this.loginForm = this.fb.group({
      username:[],
      password:[]
    })
  }

  activarUsuario(idUsuario){
    this.auth.activarUsuario(idUsuario).subscribe(result=>{
        this.toastr.success('Usuario Activado');
    })
  }
    
  togglePassword() {
    this.hide = !this.hide;
  }

  onSubmit() {
    this.credentials = this.loginForm.value;
    this.auth.authenticate(this.credentials).subscribe(
      (result: User) => { 
        if(this.auth.statusAuth == 200) {
          this.analytics.sendEvent('login', {
            idEvento: 1,
            method: 'email', // Puedes cambiarlo a 'google', 'facebook', etc., según el método de autenticación usado
            userName: this.credentials.username // Si tienes el ID del usuario autenticado
          });
          if(result.cartItems !== null) {
            if(result.cartItems.length > 0) {
              result.cartItems.forEach((prod) => {
                this.prodService.addToCart(prod)              
              })
            }
          }
          this.auth.setData(result);
          this.service.cerrarModalLogin(false);
          this.service.cerrarModalRegister(false);
          this.service.cerrarModal(false);
          window.location.reload();
        } else if(this.auth.statusAuth == 202) {
          this.service.cerrarModalLogin(false);
          this.service.cerrarModalRegister(false);
          this.service.cerrarModal(true);
          this.service.obtenerRutaRedirigir('/shop/checkout');
          this.service.vieneDeCheckout(true);
          this.service.obtenerTextoModalCodigoLogin(result.nombre)
          this.service.obtenerIdUserRegistro(result.idUsuario)
          this.service.reenviarCodigo(this.loginForm.controls.username.value);
        }
      },
      err=>{
      window.scrollTo({
        top: 0,
        behavior: "smooth", // Para un desplazamiento suave
      });
      this.analytics.sendEvent('error_login', {
        idEvento: 10,
        method: 'email',  // Método de autenticación usado
        reason: 'Credenciales incorrectas', // Mensaje del error
        userName: this.credentials.username // Si tienes el ID del usuario autenticado
      });
        this.toastr.error('Usuario o contraseña incorrectos')
      })
  }  

  changeModal(modalLogin: boolean, modalRegister: boolean) {
    this.prodService.$modalLogin.emit({
      login: modalLogin,
      register: modalRegister,
    });
  }
  
  closeModal() {
    this.service.cerrarModalLogin(false);
  }

  

  closeModalGuest(guest: any) {
    this.service.cerrarModalLogin(false);
    this.prodService.$guestUser.emit(!!guest);
  }
}
 